import React, { useState, useEffect } from 'react';
import { Link } from 'gatsby';
import { WebsiteImage } from 'components/TitleDescription';
import useSideBarDefault from 'hooks/useSideBarDefault';
import ads_default_1 from '../../images/tmp-blog-ads-1.png';
import ads_default_2 from '../../images/tmp-blog-ads-2.png';
import ads_default_3 from '../../images/tmp-blog-ads-3.png';
import {
  BlogSidebarWrapper,
  SidebarRecommend,
  SidebarOurTools,
  SidebarAds,
  SidebarOtherPlatform,
} from './styles';
import SidebarSubscribeForm from './SidebarSubscribeForm';

const Sidebar = ({ content = {}, relatedPosts, hubType, ...otherProps }) => {
  const [formValues, setFormValues] = useState({});

  useEffect(() => {
    setFormValues({
      ...JSON.parse(localStorage.getItem('ProgressiveForm')),
    });
  }, []);

  const onSubmit = data => {
    localStorage.setItem('ProgressiveForm', JSON.stringify(data));
    setFormValues(data);
  };

  const sidebarTools = {
    'HVAC Calculator': {
      title: 'HVAC Load Calculator',
      link: '/tools/hvac-load-calculator',
    },
    'Business Evaluator': {
      title: 'Business Value Calculator',
      link: '/tools/service-business-valuation-calculator',
    },
    'ROI Calculator': {
      title: 'ROI Calculator',
      link: '/roi-calculator',
    },
  };

  const defaultSideBar = useSideBarDefault();

  const defaultContent = {
    emailCapture: defaultSideBar?.emailCapture || {
      formTitle: 'Solid advice delivered to your inbox.',
    },
    featuredTools: defaultSideBar?.featuredTools || [
      'ROI Calculator',
      'HVAC Calculator',
      'Business Evaluator',
    ],
    ad1: defaultSideBar?.ad1 || {
      url: '/podcast',
      image: { image: { fluid: { src: ads_default_1 } } },
    },
    ad2: defaultSideBar?.ad2 || {
      url: '/podcast',
      image: { image: { fluid: { src: hubType === 'podcast' ? ads_default_3 : ads_default_2 } } },
    },
  };

  const cardFilter = item => {
    const url =
      hubType === 'webinar'
        ? `/${hubType}/${item.seo.pageUrl}`
        : hubType === 'podcast'
        ? `${item.node.seo.pageUrl}`
        : `/${hubType}/${item.node.slug}`;

    const photo =
      hubType === 'webinar'
        ? item.featuredImage?.image.fluid.src
        : hubType === 'podcast'
        ? item.node.coverPhoto?.image.fluid.src
        : item.node.featuredImage;

    const title =
      hubType === 'webinar'
        ? item.webinarTitle
        : hubType === 'podcast'
        ? item.node.podcastTitle
        : item.node.title;

    return {
      url: url,
      photo: photo,
      title: title,
    };
  };

  content.emailCapture = content?.emailCapture || defaultContent.emailCapture;
  content.featuredTools = content?.featuredTools || defaultContent.featuredTools;
  content.ad1 = content?.ad1?.image ? content.ad1 : defaultContent.ad1;
  content.ad2 = content?.ad2?.image ? content.ad2 : defaultContent.ad2;
  return (
    <BlogSidebarWrapper className="blog-sidebar--main-wrapper">
      {Object.keys(formValues).length < 2 && content.emailCapture && (
        <SidebarSubscribeForm
          className="test-siderail-cta-top"
          content={content.emailCapture}
          hubType={hubType}
          formValues={formValues}
          onSubmit={onSubmit}
        />
      )}

      {content.ad1?.image?.image && (
        <SidebarAds
          url={content.ad1.url}
          image={content.ad1.image.image.fluid?.src || content.ad1.image.image.file?.url}
          modalForm={content.ad1.modalForm}
          className="test-sidebar-ad-1"
          data-promocontent={content.ad1.contentInformation || ''}
          data-promoposition="sidebar_top"
        />
      )}

      {hubType === 'podcast' && otherProps.otherPlatforms && (
        <SidebarOtherPlatform>
          {otherProps.otherPlatforms.map((item, index) => {
            return (
              <a className="section-podcast-detail-content--sidebar-others-item" href={item.link}>
                <img
                  className="section-podcast-detail-content--sidebar-others-item-img"
                  src={item.logo}
                />
                <p className="section-podcast-detail-content--sidebar-others-item-title">
                  {item.title}
                </p>
              </a>
            );
          })}
        </SidebarOtherPlatform>
      )}

      {relatedPosts && relatedPosts.length > 0 && (
        <SidebarRecommend>
          <h2 className="blog-sidebar-recommend--title">
            Recommended content
            <br />
            for you
          </h2>
          <div className="blog-sidebar-recommend--content">
            {relatedPosts.slice(0, 3).map((item, index) => {
              const card = cardFilter(item);

              return (
                <Link className="blog-sidebar-recommend--content-item" to={card.url} key={index}>
                  <WebsiteImage
                    className="blog-sidebar-recommend--content-item-img"
                    src={card.photo}
                  />
                  <p className="blog-sidebar-recommend--content-item-title">{card.title}</p>
                </Link>
              );
            })}
          </div>
        </SidebarRecommend>
      )}

      {content.featuredTools && content.featuredTools.length > 0 && (
        <SidebarOurTools className="test-sidebar-tool-links">
          <h2 className="blog-sidebar-ourtools--title">Explore our tools</h2>
          <div className="blog-sidebar-ourtools--content">
            {content.featuredTools.map((item, index) => {
              return (
                <Link
                  className="blog-sidebar-ourtools--content-item"
                  to={sidebarTools[item].link}
                  key={index}
                >
                  {sidebarTools[item].title}
                </Link>
              );
            })}
          </div>
        </SidebarOurTools>
      )}

      {content.ad2?.image?.image && (
        <SidebarAds
          url={content.ad2.url}
          image={content.ad2.image.image.fluid?.src || content.ad2.image.image.file?.url}
          modalForm={content.ad2.modalForm}
          className="test-sidebar-ad-2"
          data-promocontent={content.ad2.contentInformation || ''}
          data-promoposition="sidebar_top"
        />
      )}

      {Object.keys(formValues).length < 2 && content.emailCapture && (
        <SidebarSubscribeForm
          className="test-siderail-cta-bot"
          content={content.emailCapture}
          hubType={hubType}
          formValues={formValues}
          onSubmit={onSubmit}
          sticky
        />
      )}
    </BlogSidebarWrapper>
  );
};

export default Sidebar;
